"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableTurnSlightLeftIcon = PrintableTurnSlightLeftIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableTurnSlightLeftIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M0 12.002c0 6.616 5.383 11.998 12 11.998s12-5.382 12-11.998-5.384-12.002-12-12.002-12 5.385-12 12.002zM1.080 12.002c0-6.023 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 4.428-2.655 8.239-6.451 9.953v-7.319c0-0.099-0.017-2.469-1.454-3.506-1.209-0.873-6.261-3.304-7.815-4.044l5.782-1.574c0.299-0.083 0.477-0.391 0.396-0.691-0.082-0.298-0.383-0.477-0.691-0.396l-7.065 1.921c-0.298 0.082-0.476 0.391-0.396 0.692l1.918 7.063c0.071 0.251 0.297 0.415 0.544 0.415 0.048 0 0.098-0.006 0.149-0.020 0.298-0.082 0.475-0.391 0.394-0.692l-1.556-5.724c1.473 0.704 6.551 3.146 7.68 3.96 0.804 0.581 0.985 2.070 0.987 2.595v7.554c0 0.066 0.016 0.128 0.038 0.188-1.065 0.346-2.201 0.541-3.381 0.541-6.022 0-10.92-4.898-10.92-10.918z",
    fill: color
  }));
}